import {TAUSCHBONUS_SOCS, FIVE_EURO_TAUSCHBONUS_DEVICES, TEN_EURO_TAUSCHBONUS_DEVICES, TWENTY_EURO_TAUSCHBONUS_DEVICES} from '@vfde-fe/sails-constants';

/**
 * getTauschbonusSoc
 * Get the correct soc by a given device id
 */
export const getTauschbonusSoc = (deviceId: string): string => {

    const parsedDeviceId = parseInt(deviceId, 10);

    if (FIVE_EURO_TAUSCHBONUS_DEVICES.includes(parsedDeviceId)) {
        return TAUSCHBONUS_SOCS[5];
    } else if (TEN_EURO_TAUSCHBONUS_DEVICES.includes(parsedDeviceId)) {
        return TAUSCHBONUS_SOCS[10];
    } else if (TWENTY_EURO_TAUSCHBONUS_DEVICES.includes(parsedDeviceId)) {
        return TAUSCHBONUS_SOCS[20];
    }

    return undefined;
};
